import classNames from 'classnames';
import React from 'react';
import MediaQuery from 'react-responsive';

export default class extends React.Component {
  static defaultProps = {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    forceHide: false,
    forceShow: false
  };

  getChild = (mode) => {
    if (this.props[mode]) {
      return <div>{this.props.children}</div>;
    }
    return <noscript />;
  };

  render() {
    if (this.props.forceHide || this.props.if === false) {
      return null;
    }
    if (this.props.inline && (this.props.forceShow || this.props.if === true)) {
      return (
        <span className={this.props.className} style={this.props.style}>
          {this.props.children}
        </span>
      );
    }
    if (this.props.forceShow || this.props.if === true) {
      return (
        <div className={this.props.className} style={this.props.style}>
          {this.props.children}
        </div>
      );
    }

    return (
      <div className={this.props.ClassName} style={this.props.style}>
        <MediaQuery query="screen and (max-width:767px)">{this.getChild('xs')}</MediaQuery>
        <MediaQuery query="screen and (min-width:768px) and (max-width: 991px)">
          {this.getChild('sm')}
        </MediaQuery>
        <MediaQuery query="screen and (min-width:992px) and (max-width: 1199px)">
          {this.getChild('md')}
        </MediaQuery>
        <MediaQuery query="screen and (min-width:1200px)">{this.getChild('lg')}</MediaQuery>
      </div>
    );
  }
}

export class Xs extends React.Component {
  render() {
    return <MediaQuery query="screen and (max-width:767px)">{this.props.children}</MediaQuery>;
  }
}

export class Sm extends React.Component {
  render() {
    return (
      <MediaQuery query="screen and (min-width:768px) and (max-width: 991px)">
        {this.props.children}
      </MediaQuery>
    );
  }
}

export class Md extends React.Component {
  render() {
    return (
      <MediaQuery query="screen and (min-width:992px) and (max-width: 1199px)">
        {this.props.children}
      </MediaQuery>
    );
  }
}

export class Lg extends React.Component {
  render() {
    return <MediaQuery query="screen and (min-width:1200px)">{this.props.children}</MediaQuery>;
  }
}
